// 生产计划负责人值php订单处有做判断
const grades = [{
    key:"0",
    value:"Authorized"
},{
    key:"1",
    value:"Silver"
},{
    key:"2",
    value:"Gold"
},{
    key:"3",
    value:"Platinum"
},{
    key:"4",
    value:"Distributor"
}];

export { grades };